import React, {PureComponent, useEffect, useRef, useState} from 'react';
import { useAuthContext } from '../../../contexts/AuthContext';
import { CreateAgendaRequestByComIdMutation, CreateAgendaRequestByComIdMutationVariables, CreateAgendaRequestMutation, CreateAgendaRequestMutationVariables, GetAgendaRequestQuery, GetAgendaRequestQueryVariables, GetAgendaShiftQuery, GetAgendaShiftQueryVariables, GetAgendaUserQuery, GetAgendaUserQueryVariables, ShiftsByComIdQuery, ShiftsByComIdQueryVariables, ShiftsByUserQuery, ShiftsByUserQueryVariables, UpdateAgendaRequestMutation, UpdateAgendaRequestMutationVariables, UpdateAgendaShiftMutation, UpdateAgendaShiftMutationVariables, UsersByComIdQuery, UsersByComIdQueryVariables } from '../../../graphql/API';
import { getAgendaShift, getAgendaUser, getAgendaRequest, updateAgendaRequest, updateAgendaShift, createAgendaRequest, usersByComId, createAgendaRequestByComId } from '../queries';
import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { Button, Col, Form, InputGroup, Modal, Nav, Row, Spinner, Stack } from 'react-bootstrap';
import { Link, NavLink, useLocation, useNavigate, useParams } from 'react-router-dom';
import { IoArrowRedoCircleOutline } from 'react-icons/io5';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { enUS, fr } from 'date-fns/locale';
import Cookies from 'js-cookie';
import CustomModal from '../../../components/Modals/CustomModal';
import UserImage from '../../../components/UserImage';
import { MdSwapHorizontalCircle } from "react-icons/md";
import Sidebar from '../../services/Sidebar/Sidebar';
import { v4 as uuidv4 } from 'uuid';
import Select from 'react-dropdown-select';
import { useForm } from 'react-hook-form';
import { CalendarToday } from '@mui/icons-material';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { TextField } from '@mui/material';
import DateForm from '../../services/FormComponents/DateForm';
import useDateService from '../../services/DateService';
import TopicNotificationService from '../../services/TopicService';

const CreateLeaveRequestScreen = () => {
  // AUTH
  const {userId: AuthUserId} = useAuthContext();
  // I18N
  const { t } = useTranslation();
  const savedLang = Cookies.get('language');
  // PARAMS
  const { id } = useParams<{ id: string }>();
  // NAVIGATION
  const navigate = useNavigate();
  // MODAL
  const [contentModal, setContentModal] = useState(null);
  const [linkModal, setLinkModal] = useState(null);
  const [showCustomModal, setShowCustomModal] = useState(false);
  const [footerModal, setFooterModal] = useState(true);
  // NOTIFICATION
  const {sendTopicNotification} = TopicNotificationService();
  // DATE SERVICES
  const {getTIMEZONE, getDateTimeWithTimezone} = useDateService();
  // HOME SETTINGS
  const TIMEZONE = getTIMEZONE();
  // FORM
  // const {register, control, handleSubmit, watch, reset} = useForm<RequestData>();
  // const [startAt, setStartAt] = useState<string>("");
  // const [stopAt, setStopAt] = useState<string>("");
  // const [description, setDescription] = useState<string>("");
  // TABS
  const location = useLocation();

  const {data: dataUser, loading: loadingUser, error: errorUser, refetch: refetchUser, fetchMore: fetchMoreUser} = useQuery
    <GetAgendaUserQuery, GetAgendaUserQueryVariables>(getAgendaUser,
      {variables: {userId: AuthUserId}});

  // const {data: dataShift, loading: loadingShift, error: errorShift, refetch: refetchShift, fetchMore: fetchMoreShift} = useQuery
  //     <GetAgendaShiftQuery, GetAgendaShiftQueryVariables>(getAgendaShift, 
  //       {variables: {shiftId: id,
  //     }});
  // const {data: dataShift, loading: loadingShift, error: errorShift, refetch: refetchShift, fetchMore: fetchMoreShift} = useQuery
  //       <GetAgendaShiftQuery, GetAgendaShiftQueryVariables>(getAgendaShift, 
  //         {variables: {shiftId: "Shift-f860c509-300f-48ba-98db-269a2edf01f1",
  //       }});

  const [fetchDataUsers, {data: dataUsers, loading: loadingUsers, error: errorUsers, 
        refetch: refetchUsers, fetchMore: fetchMoreUsers}] = useLazyQuery
        <UsersByComIdQuery, UsersByComIdQueryVariables>(usersByComId);
    
  const [doCreateRequest] = useMutation<CreateAgendaRequestByComIdMutation, CreateAgendaRequestByComIdMutationVariables>(createAgendaRequestByComId, {fetchPolicy: "network-only"});

  const user = dataUser?.getAgendaUser;
  // const shift = dataShift?.getAgendaShift;

  useEffect(() => {
    document.title = t('request.createLeaveTab');
  }, []);

  useEffect(() => {
    if (!user) return;
    if (!user.comId) return;
    fetchDataUsers({variables: {comId: user.comId}});
  }, [user]);

  const users = dataUsers?.usersByComId?.items || [];
  
  const generateCustomId = () => {
    const prefix = "Request";
    const uniquePart = uuidv4();
    return `${prefix}-${uniquePart}`;
  };

  // console.log(dataShifts?.shiftsByUser);
  if (!user || !users) {
    return (
        <div className="spinnerContainer">
            {/* <Spinner animation="border" role="status" style={styles.spinner as React.CSSProperties}> */}
            <Spinner animation="border" role="status" className="spinner">
                <span className="visually-hidden">Loading...</span>
            </Spinner>   
        </div>
    )
  };

  const createRequest = async (startAt: string, stopAt: string, description: string, error: boolean) => {
    setShowCustomModal(false);
    try {
      const date = new Date();
      const now = date.toISOString();
      const requestId = generateCustomId();
      const start = getDateTimeWithTimezone(startAt.toString(), TIMEZONE);//.split('T')[1];
      const stop = getDateTimeWithTimezone(stopAt.toString(), TIMEZONE);//.split('T')[1];
      const response = await doCreateRequest({
        variables: {
          // input: {
            requestId: requestId,
            userId: AuthUserId,
            shiftId: "Shift_0",         // Needed for index
            comId: user.comId,          // Needed for index
            description: description,
            type: "leave",              // Needed for index
            suggestedUser: AuthUserId,  // Needed for index
            suggestedUserUsername: user.username,
            suggestedUserImage: user.image,
            startAt: start,
            stopAt: stop,
            accepted: false,
            confirmed: false,
            completed: false,
            deleted: false,
            updatedAt: now,
            createdAt: now,
          // }
        }
      });
      // console.log("RESPONSE", response)
      for (const usr of users) {
        if (usr.type === "MANAGER") {
          if (usr.userId !== AuthUserId) {
            await sendTopicNotification(
              user.username,                                          // title
              t('request.createLeaveTab') + ": " + description,       // description
              undefined,                                              // FCMtoken
              user.userId ?? undefined,                               // senderId
              requestId,                                              // dataID
              start,                                                  // startAt
              stop,                                                   // stopAt
              "leaveRequest");                                        // type
          }
        } 
      }
      
      { user.type === 'MANAGER' ?
        navigate(t('link.requests_leave'), { state: { status: "bg-success", title: "", toastMessage: t('toast.leaveCreated') }})
      :
        navigate(t('link.requests_leave'), { state: { status: "bg-success", title: "", toastMessage: t('toast.leaveCreated') }})
      }
      
    } catch(error) {
        alert("Error on Shift Acceptation: " + error);
    };
  };

  const leaveRequest = (startAt: string, stopAt: string, description: string, error: boolean) => {
    // navigate('/requests/swap/shift/' + id);
    // console.log("test", startAt)
    // console.log("test", stopAt)
    // console.log("test", description)
    // console.log("test", error)

    if (!error) {
      // const username = userInfo.split("!!!#%#!!!")[1];
      setFooterModal(false);
      setContentModal(<>
        <Modal.Header closeButton>
          <Modal.Title>{t('shift.areYouSure')}</Modal.Title>
            </Modal.Header>
      
            <Modal.Body>
              <p>{t('request.leaveMessage')}</p></Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowCustomModal(false)}>
                {t('shift.cancel')}
              </Button>
              <Button variant="primary" onClick={() => createRequest(startAt, stopAt, description, error)}>
                {t('request.ask')}
              </Button>
            </Modal.Footer>
        </>);
      setShowCustomModal(true);
    } else {
      setContentModal(<>
        <Modal.Header closeButton>
          <Modal.Title>{t('request.request_error')}</Modal.Title>
            </Modal.Header>
      
            <Modal.Body>
              <p>{t('error.dates_required')}</p>
            </Modal.Body>
        </>);
      setShowCustomModal(true);
    }
  } 

  return (
    <>
      <CustomModal
        show={showCustomModal}
        onHide={() => setShowCustomModal(false)}
        link={linkModal}
        children={contentModal}
        isFooter={footerModal}
        // animation={true}
      />
      <div className="d-flex">
        <Sidebar user={user} />
        <div className="users-container flex-grow-1 p-3">
        <div className="users-container">
          { user.type === "MANAGER" ?
              <Nav variant="tabs" activeKey={location.pathname} className="nav-fill w-100 justify-content-center" style={{borderBottom: 0}}>
                <Nav.Item>
                  <Nav.Link as={NavLink} to={t('link.leave_create')} eventKey={t('link.leave_create')} style={{textDecoration: 'none', fontWeight: 'bold', color: '#BBB', backgroundColor: '#f5f5f5', borderBottom: 0}}>
                    {t('request.createLeaveTab')}
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link as={NavLink} to={t('link.requests_leave')} eventKey={t('link.requests_leave')} style={{textDecoration: 'none', fontWeight: 'bold', color: '#11947e'}}>
                    {t('request.leaveTab')}
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link as={NavLink} to={t('link.leave_management')} eventKey={t('link.leave_management')} style={{textDecoration: 'none', fontWeight: 'bold', color: '#11947e'}}>
                    {t('request.managerLeaveTab')}
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            :
              <Nav variant="tabs" activeKey={location.pathname} className="nav-fill w-100 justify-content-center" style={{borderBottom: 0}}>
                <Nav.Item>
                  <Nav.Link as={NavLink} to={t('link.leave_create')} eventKey={t('link.leave_create')} style={{textDecoration: 'none', fontWeight: 'bold', color: '#BBB', backgroundColor: '#f5f5f5', borderBottom: 0}}>
                    {t('request.createLeaveTab')}
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link as={NavLink} to={t('link.requests_leave')} eventKey={t('link.requests_leave')} style={{textDecoration: 'none', fontWeight: 'bold', color: '#11947e'}}>
                    {t('request.leaveTab')}
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            }
            <Stack direction="vertical" gap={3} className="w-100 p-3" style={{border: '1px solid #DDD', borderTop: 0, borderRadius: 10, borderTopLeftRadius: 0, backgroundColor: '#f5f5f5'}}>
            
            {/* <Form className="register-form"> */}
              <h2 className="text-center">{t('request.transferLeaveTitleForm')}</h2>
              {/* <InputGroup>
                <CalendarToday  color="action" />
              </InputGroup> */}
              <InputGroup>
                <DateForm
                  onSubmit={(startAt, stopAt, description, error) => {
                    // setStartAt(startAt);
                    // setStopAt(stopAt);
                    // setDescription(description);
                    // Appelle ici ta mutation GraphQL avec startAt / stopAt (format ISO 8601)
                    // console.log("Créer avec :", startAt, stopAt);
                    leaveRequest(startAt, stopAt, description, error);
                    // ex: createEvent({ variables: { startAt, stopAt, ... } })
                  }}
                />
              </InputGroup>
              {/* <InputGroup>
                <Button type="submit" onClick={handleSubmit(leaveRequest)} disabled={loadingUsers}>{loadingUsers ? t('signup.loading') : t('request.submitRequest')}</Button>
              </InputGroup> */}
            {/* </Form> */}
            </Stack>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateLeaveRequestScreen;


